export default "__VITE_ASSET__C9JV_OmK__"